var render = function render(){var _vm=this,_c=_vm._self._c;return _c('datepicker',{staticClass:"base-datepicker",attrs:{"language":_vm.ja,"placeholder":"Select Date","format":"yyyy年M月","input-class":"base-datepicker__input","calendar-class":"base-datepicker__calendar","wrapper-class":"base-datepicker__wrapper"},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }